import { SOCIAL_MEDIA_ACCOUNTS } from '@/constants/social';
import gtm from '@/lib/gtm';
import { openSocialShareWindow } from '@/lib/social';
import { copyToClipboard } from '@/lib/utils';
import { useEffect, useState } from 'react';

const ANALYTICS_LOCATION = 'Share Buttons';

const GOOGLE_PREFERRED_SOURCE_URL = 'https://google.com/preferences/source?q=front.com';

type Props = {
  pageUrl: string;
  title: string;
};

export const useBlogHeader = ({ pageUrl, title }: Props) => {
  const [showPopup, setShowPopup] = useState(false);

  const linkedInAccount = SOCIAL_MEDIA_ACCOUNTS.find((account) => account.handle === 'linkedin');

  const linkedInShareUrl = linkedInAccount?.shareUrl || null;

  const summarizeQuery = encodeURIComponent(`Summarize this page: ${pageUrl}`);
  const chatGptShareLink = `https://chatgpt.com/?q=${summarizeQuery}`;
  const claudeShareLink = `https://claude.ai/new?q=${summarizeQuery}`;
  const googleSourceLink = GOOGLE_PREFERRED_SOURCE_URL;

  useEffect(() => {
    if (showPopup) {
      setTimeout(() => setShowPopup(false), 2000);
    }
  }, [showPopup]);

  const onEmailIconClick = () => {
    gtm.track('click', {
      element_type: 'button',
      element_label: 'Email',
      location: ANALYTICS_LOCATION,
    });
  };

  const onCopyLinkIconClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    copyToClipboard(pageUrl);
    setShowPopup(true);
    gtm.track('click', {
      element_type: 'button',
      element_label: 'Copy to clipboard',
      location: ANALYTICS_LOCATION,
    });
  };

  const onLinkedInIconClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (!linkedInShareUrl) return;

    openSocialShareWindow(linkedInShareUrl(pageUrl, title));

    gtm.track('click', {
      element_type: 'button',
      element_label: 'LinkedIn',
      location: ANALYTICS_LOCATION,
    });
  };

  const onChatGptIconClick = () => {
    gtm.track('click', {
      element_type: 'button',
      element_label: 'ChatGPT',
      location: ANALYTICS_LOCATION,
    });
  };

  const onClaudeIconClick = () => {
    gtm.track('click', {
      element_type: 'button',
      element_label: 'Claude',
      location: ANALYTICS_LOCATION,
    });
  };

  const onGoogleSourceIconClick = () => {
    gtm.track('click', {
      element_type: 'button',
      element_label: 'Google preferred source',
      location: ANALYTICS_LOCATION,
    });
  };

  return {
    onEmailIconClick,
    onCopyLinkIconClick,
    onLinkedInIconClick,
    onChatGptIconClick,
    onClaudeIconClick,
    onGoogleSourceIconClick,
    showPopup,
    linkedInShareLink: linkedInShareUrl ? linkedInShareUrl(pageUrl, title) : '',
    chatGptShareLink,
    claudeShareLink,
    googleSourceLink,
  };
};
